<span *ngIf="activeUserId === data.value.activeUserId" class="fw-bold" data-test-id="activity-downloaded-you">{{
  'ACTIVITY_YOU' | translate
}}</span>
<app-activities-navigate-profile
  *ngIf="activeUserId !== data.value.activeUserId"
  [user]="data.value.user"
  [dataTestId]="'activity-downloaded-navigate-to-profile'"
  [isDialog]="isDialog"
  (submit)="onSubmit()"
></app-activities-navigate-profile>
{{ 'ACTIVITY_DOWNLOADED' | translate }}
<span *ngIf="isDialog" data-test-id="activity-downloaded-this">{{ 'ACTIVITY_THIS' | translate }}&nbsp;</span>
<span data-test-id="activity-downloaded-file">{{ 'ACTIVITY_FILE' | translate }}</span>
<app-activities-display-popup
  *ngIf="!isDialog"
  [rowIndex]="data.rowIndex"
  [value]="data?.value"
  [entityName]="data.value.entity_name"
  [dataTestId]="'file-'"
  (displayPopup)="onDisplayPopup($event)"
></app-activities-display-popup>
